import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
} from "design-system/molecules/Select"
import { Clock } from "lucide-react"
import { useTranslation } from "react-i18next"
import { getTimeDimensionOptions, TimeDimension } from "schema"

type Props = {
  value: TimeDimension
  range: { from: Date; to: Date }
  dimensions?: readonly TimeDimension[]
  onChange: (value: TimeDimension) => void
}

export function TimeDimensionSelector({ value, range, dimensions, onChange }: Props) {
  const { t } = useTranslation()

  const options = getTimeDimensionOptions(range, dimensions)

  if (options.length <= 1) {
    return (
      <div className="flex h-10 shrink-0 items-center gap-2 rounded-md border border-border px-3 text-sm text-muted-foreground">
        <Clock className="h-4 w-4" />
        {t(`shared.timeRange.dimension.${value}`)}
      </div>
    )
  }

  return (
    <Select value={value} onValueChange={(next) => onChange(next as TimeDimension)}>
      <SelectTrigger className="w-auto gap-2" aria-label={t("shared.timeRange.interval")}>
        <Clock className="h-4 w-4" />
        {t(`shared.timeRange.dimension.${value}`)}
      </SelectTrigger>
      <SelectContent align="end">
        <SelectGroup>
          <SelectLabel>{t("shared.timeRange.interval")}</SelectLabel>
          {options.map((option) => (
            <SelectItem key={option} value={option}>
              {t(`shared.timeRange.dimension.${option}`)}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
